function PriceLoader() {
    return (
        <span className="fireknife-price-loader" aria-label="Loading price" role="status">
            <span className="fireknife-price-loader__dot"></span>
        </span>
    );
}

export default PriceLoader;
